import { cva } from "class-variance-authority";
import { ComponentProps, useContext } from "react";
import { Button } from "../../../button";
import { DrawerSelectContext } from "../../drawer-select.context";
import styles from "./drawer-select-content-inline.module.css";

const css = cva([styles.Content], {
  variants: {
    isOpen: {
      true: styles.IsOpen,
      false: styles.IsClosed,
    },
  },
});

export type DrawerSelectContentInlineProps = ComponentProps<"div">;

export function DrawerSelectContentInline({
  className,
  children,
  ...props
}: DrawerSelectContentInlineProps) {
  const {
    isOpen,
    handleClear,
    handleApply,
    multiple,
    applyButtonText,
    clearButtonText,
  } = useContext(DrawerSelectContext);

  const applyButtonLabel = applyButtonText ?? "Confirmar";
  const clearButtonLabel = clearButtonText ?? "Limpar";
  const showFooter = multiple === true;

  return (
    <div className={css({ className, isOpen })} {...props}>
      {children}
      {showFooter && (
        <div className={styles.Footer}>
          <Button variant="situational" size="small" onClick={handleClear}>
            {clearButtonLabel}
          </Button>
          <Button variant="situational" size="small" onClick={handleApply}>
            {applyButtonLabel}
          </Button>
        </div>
      )}
    </div>
  );
}
